import React, { useContext, useEffect, useState, useRef } from 'react';
import { useSize } from 'ahooks';
import { Application, resource } from "@yulintu/freesia-bootstrap";
import './index.less';

export default function Item(props) {
    const { config, onClick } = props;

    const { title, logoImage, logoImageStyle } = config
    return <div className='appItem' onClick={onClick}>
        <div className='itemContent'>
            <img src={resource(`${logoImage}`)} style={logoImageStyle} />
            <div className='title'>{title}</div>
        </div>
    </div>
}